import { Component, ElementRef, HostListener, inject, ViewChild } from '@angular/core';

@Component({
  selector: 'app-google-translate',
  templateUrl: './google-translate.component.html',
  styleUrls: ['./google-translate.component.scss']
})
export class GoogleTranslateComponent {
  private elementRef = inject(ElementRef);
    @ViewChild('logoContainer') logoContainer!: ElementRef;

    showLanguages: boolean = false;
    currentLang: string = 'pt-br'


    @HostListener('document:click', ['$event'])
    handleClickOutside(event: Event): void {
      if (!this.elementRef.nativeElement.contains(event.target)) {
        this.showLanguages = false;
      }
    }

    changeLanguage(language: string) {
      this.showLanguages = false;
    }

    handleClickTogglenOptions() {
      this.showLanguages = !this.showLanguages;
    }


  ngOnInit(): void {
    this.addGoogleTranslateScript();
  }

  addGoogleTranslateScript() {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = '//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
    document.body.appendChild(script);

    (window as any).googleTranslateElementInit = () => {
      new (window as any).google.translate.TranslateElement({
        pageLanguage: 'pt',
        includedLanguages: 'en,es,fr,de,it,pt,zh-CN,zh-TW',
        layout: (window as any).google.translate.TranslateElement.InlineLayout.SIMPLE,
      }, 'google_translate_element');
    };
  }
}
